

import ClinicAdminDashboard from "../Components/Dashboard/Dashboard";
import ChangePassword from "../Components/MyProfile/change-password";
import NewReport from "../Components/InvestigationReport/NewReport";
import Reports from "../Components/InvestigationReport/Reports";
import ViewReport from "../Components/InvestigationReport/ViewReport";
import SearchPatient from "../Components/SearchPatient/SearchPatient";

export const routes = [
	// Dashboard
	{ path: `${process.env.PUBLIC_URL}/dashboard`, Component: <ClinicAdminDashboard />, menu_key: 'dashboard' },

	// Change Password
	{ path: `${process.env.PUBLIC_URL}/change-password`, Component: <ChangePassword /> },
	
	// Search Patient
	{ path: `${process.env.PUBLIC_URL}/search-patient`, Component: <SearchPatient /> },

	// Report
	{ path: `${process.env.PUBLIC_URL}/reports`, Component: <Reports /> },
	{ path: `${process.env.PUBLIC_URL}/add-report`, Component: <NewReport /> },
	{ path: `${process.env.PUBLIC_URL}/view-report/:id`, Component: <ViewReport /> },

];
